import { render, staticRenderFns } from "./SuspectedPlayersTable.vue?vue&type=template&id=76277b43&scoped=true&"
import script from "./SuspectedPlayersTable.vue?vue&type=script&lang=js&"
export * from "./SuspectedPlayersTable.vue?vue&type=script&lang=js&"
import style0 from "./SuspectedPlayersTable.vue?vue&type=style&index=0&id=76277b43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76277b43",
  null
  
)

export default component.exports